import { useLayoutEffect } from "react";
import styles from "./index.css";
import content from "app-content";
import webContextProvider from "../../../../providers/webContextProvider";
import renderQRCode from "@asosteam/asos-web-app-download-qr-code";
import { logError } from "../../../../monitoring";

const QR_CODE_URL =
  "https://content.asos-media.com/-/media/app-download/app-download-qr-code.png";

const AppDownloadBanner = () => {
  const handleQrCodeError = error => {
    logError(error instanceof Error ? error : new Error(String(error)), {
      qrCodeUrl: QR_CODE_URL
    });
  };

  const webContext = webContextProvider();
  const floor = webContext.floor;
  const affId = webContext.affiliateId
    ? `&affid=${webContext.affiliateId}`
    : "";
  const customerRef = webContext.customerId
    ? `&custref=${webContext.customerId}`
    : "";

  //Initializing Smart Script arguments
  const oneLinkURL = "https://asos-medialabs.onelink.me/PXyX/";
  // If a media source key is NOT FOUND on the link and NO default value is found, the script will return a null string
  const mediaSource = { keys: ["media"], defaultValue: "qr_code" };
  const channel = { keys: ["channel"], defaultValue: "web-saved-lists" };
  const campaign = { keys: ["campaign"], defaultValue: "download_the_app" };
  const deepLinkValue = {
    keys: ["deepLink"],
    defaultValue: encodeURIComponent(
      `asos://home?channelref=web_dta_qr&floor=${floor}${affId}${customerRef}`
    )
  };

  useLayoutEffect(() => {
    try {
      renderQRCode(oneLinkURL, mediaSource, campaign, deepLinkValue, channel);
      const link = document.querySelector("#qr-code-container a");
      if (link) {
        link.setAttribute("aria-label", content.app_download_qr_alt);
      }
    } catch (error) {
      handleQrCodeError(error);
    }
  }, []);

  return (
    <div className={styles.appDownloadBannerContainer}>
      <div className={styles.appDownloadBanner}>
        <h2 className={styles.bannerHeading}>
          {content.download_the_app_cta_title}
        </h2>

        <div id="qr-code-container" className={styles.qrCodeContainer}>
          <p className={styles.bannerTagline}>
            {content.saved_items_app_download_banner_description}
          </p>
        </div>

        <div className={styles.bannerRating}>
          <span
            className={styles.starsContainer}
            aria-label="5 stars"
            role="img"
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <span key={index} className={styles.star} aria-hidden="true" />
            ))}
          </span>
          <span className={styles.downloadsText}>
            {content.order_confirmation_app_download_banner_number_of_downloads}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
